import graphqlClient from "@/GQLClient";
import {
  type AppExternalActivityInput,
  SaveAppConnectionsScreenDocument,
} from "@/graphql/generated-types";
import SentryGraphQLError from "@/helpers/exceptions/SentryGraphQLError";

const saveAppConnectionsScreen = async (app: AppExternalActivityInput) => {
  const response = await graphqlClient.mutate({
    mutation: SaveAppConnectionsScreenDocument,
    variables: { app },
  });

  if (response.data?.app?.saveAppConnectionsScreen?.success) {
    return response.data.app.saveAppConnectionsScreen.id;
  }

  throw new SentryGraphQLError();
};

export default {
  saveAppConnectionsScreen,
};
